module.exports = __webpack_public_path__ + "static/media/me_wedding_compressed_cropped_2.baeaba70.jpg";